<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modalLabel">
      {{
      subrole
      ? ("SETTINGS.SUBROLES.FORM.UPDATE_TITLE" | translate)
      : ("SETTINGS.SUBROLES.FORM.NEW_TITLE" | translate)
      }}
    </h4>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" style="color: black">
      <!-- <div class="mb-1">
          <label class="form-label">{{
            "SETTINGS.SUBROLES.FORM.ROLE" | translate
            }}</label>
          <ngx-select formControlName="role" appendTo="body" [items]="roles"
            [ngClass]="{ 'is-invalid': submitted && formCtrl.role.invalid}">
          </ngx-select>
        </div> -->
      <div class="mb-1">
        <label class="form-label">{{
          "SETTINGS.SUBROLES.FORM.DESCRIPTION" | translate
          }}</label>
        <input class="form-control" type="text" formControlName="description"
          [ngClass]="{ 'is-invalid': submitted && formCtrl.description.invalid}" />
      </div>
      <h4>{{ "SETTINGS.SUBROLES.FORM.PERMISSIONS.TITLE" | translate }}</h4>
      <span *ngFor="let permission of tree">
        <ng-container *ngTemplateOutlet="teste; context: { permission: this.permission }">
        </ng-container>
      </span>
    </form>
  </div>
  <div class="mt-1 mb-2 d-flex justify-content-center" *ngIf="form.enabled">
    <button *ngIf="this.subrole" class="btn btn-primary waves-effect waves-light btnSaveBottom mt-1 btnSaveMinW2"  (click)="submit()">
      {{'SETTINGS.SUBROLES.TABLE.UPDATE_LINE'|translate}}
    </button>
    <button *ngIf="!this.subrole" class="btn btn-primary waves-effect waves-light btnSaveBottom mt-1 btnSaveMinW2"  (click)="submit()">
      {{'SETTINGS.SUBROLES.TABLE.ADD_LINE'|translate}}
    </button>
  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-warn btn-action" (click)="close()">
      <i class="mdi mdi-close"></i>
      {{ "MISC.CANCEL" | translate }}
    </button>
    <button *ngIf="form.enabled" type="button" class="btn btn-success btn-action" (click)="submit()">
      <i class="mdi mdi-content-save"></i>
      {{ "MISC.SAVE" | translate }}
    </button> 
  </div>-->
</ng-template>

<ng-template #teste let-parent="permission">
  <div class="form-check" class="mt-1"
    style="border-bottom: 1px solid #f1f1f1; display: flex; flex-direction: row; align-content: center; align-items: center;">
    <i *ngIf="parent.childs.length > 0" [class]="parent.collapsed ? 'mdi mdi-chevron-right' : 'mdi mdi-chevron-down'"
      (click)="parent.collapsed = !parent.collapsed" style="font-size: '18px'; width: '20px'"></i>
    <span *ngIf="parent.childs.length === 0" style="margin-right: '20px'"></span>
    <input [id]="'customCheck' + parent.permission" type="checkbox" style="margin: auto 0;" class="form-check-input"
      [indeterminate]="
          parent.childs.length > 0 ? allChildsSelected(parent) : false" [(ngModel)]="parent.selected"
      (ngModelChange)="onParentChange(parent)" [disabled]="disabledTree" />
    <label [for]="'customCheck' + parent.permission" style="margin: auto 8px;">
      {{parent.permission | xTranslateKey:'permission' | translate}}</label>
  </div>

  <div *ngIf="parent.collapsed === false">
    <div *ngFor="let child of parent.childs" class="ms-3">
      <ng-container *ngTemplateOutlet="teste; context: { permission: child }">
      </ng-container>
    </div>
  </div>
</ng-template>